import Swiper, { Navigation, EffectFade, Autoplay, Pagination } from 'swiper';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let sliderOptions = {
    modules: [Navigation, Autoplay, EffectFade, Pagination],
    loop: true,
    spaceBetween: 0,
    speed: 1300,
    grabCursor: true,
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: { crossFade: true },
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    autoplay: {
        delay: 8000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false
    },
    on: {
        slideChange: function (swiper) {
            setTimeout(function () {
                getPaginationPosition()
            }, 1)

        },
        slideChangeTransitionEnd: function (swiper) {
        }
    }
};

$(window).resize(function () {
    if($('.swiper-pagination').length > 0) {
        getPaginationPosition()
    }
});

function getPaginationPosition() {
    let margin = 40;
    if (window.matchMedia("(max-width: 766px)").matches) {
        margin = 20;
    }
    const activeText = $('.splash-home__slider .swiper-slide-active .splash-home__text-wrapper')
    $('.swiper-pagination').css('top', (activeText.position().top + activeText.height() + margin) + 'px')
    $('.swiper-pagination').css('left', (activeText.position().left + 2) + 'px')
}


(function ($) {

    let slider = new Swiper(".splash-home__slider.active-slider", sliderOptions);

    if($('.swiper-pagination').length > 0) {
        setInterval(function() {
            getPaginationPosition()
        }, 1)
    }

    const dotsParallax = $('.splash-home__dots-img');
    if (dotsParallax) {
        ScrollTrigger.matchMedia({
            "(max-width: 766px)": function () {
                gsap.set(dotsParallax, {
                    clearProps: 'all'
                })
            },
            "(min-width: 766px)": function () {
                gsap.fromTo(dotsParallax, {
                    y: '-5%'
                }, {
                    y: '15%',
                    scrollTrigger: {
                        trigger: dotsParallax,
                        start: 'top bottom',
                        end: 'bottom top',
                        scrub: 1,
                    }
                })

                ScrollTrigger.addEventListener("refreshInit", () => {
                    gsap.set(dotsParallax, {
                        clearProps: 'x'
                    })
                });
            }
        })
    }


    jQuery(document).ready(function ($) {
        $('.splash-home__scroll-to-circ').on('click', function (e) {
            // e.preventDefault();
            var target = this.hash,
                $target = $(target);
            $('html, body').stop().animate({
                'scrollTop': $target.offset().top - 20
            }, 900, 'swing', function () {
                window.location.hash = target;
            });
        });
    });



})(jQuery);
